import {createAction} from "@reduxjs/toolkit";

export const setChatPageChannelUrl = createAction<string | undefined>("ots-ui/chat-page/setChannelUrl");
